<!--
 * @Author: lee 15472300+li-shaoang@user.noreply.gitee.com
 * @Date: 2025-02-18 16:26:48
 * @LastEditors: lee 15472300+li-shaoang@user.noreply.gitee.com
 * @LastEditTime: 2025-06-16 10:44:54
 * @FilePath: \zhucai_user\src\pages\exam\result.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="mb50">
    <el-breadcrumb
      separator-class="el-icon-arrow-right"
      class="container mb10 mt10"
    >
      <el-breadcrumb-item :to="{ path: '/qbank' }">题库中心</el-breadcrumb-item>
      <el-breadcrumb-item>题库练习</el-breadcrumb-item>
    </el-breadcrumb>

    <div class="container" v-loading="isLoading">
      <div class="BGwhite pad30 gray1 flex radius8 mb20">
        <div class="top-left">
          <img src="@/assets/img/home/42.png" alt="" />
        </div>
        <div class="top-center flex1">
          <p class="name">{{ detail.ExerciseName }}</p>
          <!-- <p class="content">
            <span>练习模式：{{ detail.EQTypeTxt }}</span>
            <span>题型：{{ detail.EModTypeTxt }}</span>
          </p> -->
        </div>
      </div>
      <div class="pad30 result">
        <div
          class="result-img"
          :class="detail.IsPass == true ? 'pass' : 'fail'"
        >
          <span class="GetScore">{{ detail.GetScore }}</span>
        </div>
        <div class="top-center flex1">
          <p class="content">
            <span>题量：{{ detail.QuesNum }}</span>
            <span>练习用时：{{ detail.UseTime }}</span>
            <span>正确率：{{ detail.RightRate }}%</span>
          </p>
          <el-button
            type="primary"
            class="hand"
            @click="hand()"
            v-loading="isLoading"
            >重新开始</el-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Exercise_Reset, Exercise_GetResult } from "@/api/exam";
export default {
  name: "Exam_result",
  data() {
    return {
      detail: {},
      isLoading: false,
    };
  },
  watch: {
    "$route.query.UEID"() {
      this.getDetail();
    },
  },

  methods: {
    getDetail() {
      this.isLoading = true;
      Exercise_GetResult({ UEID: this.$route.query.UEID })
        .then((res) => {
          this.detail = res.data;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    hand() {
      this.$router.replace({
        path: "/qbankCreate",
        query: {
          ExerciseID: this.$route.query.ExerciseID,
        },
      });
      // this.isLoading = true;
      // Exercise_Reset({ UEID: this.$route.query.UEID })
      //   .then((res) => {
      //     this.$router.push({
      //       path: "/exam/exercises",
      //       query: {
      //         UEID: res.data.UEID,
      //       },
      //     });
      //   })
      //   .finally(() => {
      //     this.isLoading = false;
      //   });
    },
  },
  created() {
    this.getDetail();
  },
};
</script>

<style lang="scss" scoped>
.red {
  background: #ffe6e8;
  border-radius: 4px;
  text-align: center;
  color: #eb525c;
  width: 57px;
  line-height: 24px;
  cursor: pointer;
  transition: all 0.2s;
  &:hover {
    background: #eb525c;
    color: white;
  }
}
.top-left {
  width: 70px;
  height: 70px;
  margin-right: 30px;
  img {
    width: 100%;
    height: 100%;
  }
}
.top-center {
  .name {
    font-weight: bold;
    font-size: 24px;
    color: #333333;
  }
  .content {
    font-size: 18px;
    color: #666666;
    span {
      margin-right: 50px;
    }
  }
}
.result {
  height: 588px;
  background: #ffffff;
  border-radius: 10px;
  text-align: center;
  .hand {
    margin-top: 50px;
    width: 144px;
    height: 52px;
    background: #1d79ff;
    border-radius: 6px;
    font-size: 18px;
    color: #ffffff;
  }
  .content {
    padding-left: 40px;
  }
  .result-img {
    margin: 50px auto;
    margin-bottom: 20px;
    width: 168px;
    height: 172px;
    background: url("~@/assets/img/home/66.png") no-repeat;
    background-size: 100% 100%;
    display: flex;
    justify-content: center;
    .GetScore {
      font-weight: bold;
      font-size: 80px;
      color: #125feb;
      align-self: center;
    }
  }
  .fail {
    width: 168px;
    height: 172px;
    background: url("~@/assets/img/home/66.png") no-repeat;
    background-size: 100% 100%;
    .GetScore {
      font-weight: bold;
      font-size: 80px;
      color: #707070;
      align-self: center;
    }
  }
}
</style>
